<template>
  <custom-dialog width="490px" :showClose="false" title="退费" v-if="visibleObj.chargeRefundDialog"
    :visible="visibleObj.chargeRefundDialog" @close="dialogVisible('chargeRefundDialog')">
    <div class="refund" slot="content" v-loading="loading">
      <div class="price-warp"><span class="size16 mr2">¥</span>{{ price }}</div>
      <div>
        <div class="refund-item">
          <div class="error_tips" v-if="ybRecord.length > 0"><span class="iconfont icon-tishi colorFE8F mr4"></span>医保退费：该笔包含医保支付，仅支持整单退费</div>
          <div class="tips">
            <span class="iconfont icon-tishi color1890 mr4"></span>
            <div>
              <div>医保退费：医保的项目只能使用医保原路退还</div>
              <div class="mt4">会员钱包退费：使用会员钱包支付的费用，只能原路退还</div>
            </div>
          </div>
          <div class="input-warp disabled" v-for="item in ybRecord" :key="item.orderPayNumber">
            <div class="input-label">医保{{ item.isMutualAidPay ? '共济' : '' }}</div>
            <custom-input size="medium" disabled v-model.trim="item.payPrice"></custom-input>
            <div class="input-tips">原路退还</div>
          </div>
        </div>
        <div class="refund-item">
          <div class="color6671">其他支付方式退费：</div>
          <el-radio-group v-model="refundWay" class="mt14" @input="changeRefundWay">
            <el-radio :label="1">原路退还</el-radio>
            <el-radio :label="2" v-if="!notYbRecord.some(v => { return v.payWay == '8' || v.payWay == '12' })">直接退现金</el-radio>
          </el-radio-group>
          <div v-if="refundWay == '1'">
            <div class="input-warp" v-for="item in notYbRecord" :key="item.orderPayNumber">
              <div class="input-label">{{ item.payWay | filterPayWay(PAY_WAY) }}</div>
              <el-input-number @change="amountChange($event, $event, item)" size="medium" :max="showMax(item)"
                v-model.trim="item.refundAmount" :disabled="item.payWay == '8' || item.payWay == '12'"></el-input-number>
              <div class="input-tips disabled" v-if="item.payWay == '8'">{{ item.memberPhone }}</div>
              <div class="input-tips" v-else>最高可退：¥{{ showMax(item) }}</div>
            </div>
            <div class="input-warp disabled">
              <div class="input-label">现金</div>
              <el-input-number disabled size="medium" v-model.trim="cash"></el-input-number>
              <div class="input-tips">自动计算</div>
            </div>
          </div>
          <div class="input-warp disabled" v-else>
            <div class="input-label">现金</div>
            <el-input-number size="medium" disabled v-model.trim="cash"></el-input-number>
            <!-- <div v-if="item.payWay!='2'" class="input-tips">最高可退：¥{{ item.payPrice }}</div> -->
          </div>
        </div>
      </div>
      <custom-input size="medium" v-model.trim="refundObj.refundReason" placeholder="请填写退费原因"></custom-input>
      <div class="mt20 textRight">
        <custom-button type="info" size="medium" @click="dialogVisible('chargeRefundDialog')">取消</custom-button>
        <custom-button type="primary" size="medium" @click="confirm">确定</custom-button>
      </div>
    </div>
    <div slot="footer"></div>
  </custom-dialog>
</template>

<script>
import CustomDialog from '@/components/customDialog/CustomDialog'
import CustomInput from '@/components/CustomInput'
import { payDTO, CommonDTO } from '@/DTO/index'
import { dictText } from '@/utils/validateBase'
import { isNull, isEmptyArray, deepClone, isNullObj } from '@/utils/validateBase'
import { cancelSettlement, gjCancelSettlement } from '@/utils/yibaoTools'
import { Utils } from '@/utils/utils'
export default {
  // 定义引入的组件
  components: { CustomDialog, CustomInput },
  props: {
    visibleObj: {
      type: Object,
      default: () => { return {} }
    },
    dialogObj: {
      type: Object,
      default: () => { return {} }
    },
  },
  data() {
    return {
      refundWay: 1,
      orderId: '',//就诊id
      ybRecord: [],//医保退费项目
      notYbRecord: [],//非医保退费项目
      refundObj: {
        refundTaskId: '',
        refundReason: '',
        taskDetails: null,
      },
      cash: '',//现金
      price: 0,
      loading: false,
      ybTotal: 0,//医保支付总金额
      PAY_WAY: [],
    }
  },
  //变量监听
  watch: {},
  computed: {
    computedMaxRefund() {
      return function (item) {
        let max = item.payPrice
        if (!isNull(item.refundList) && !isEmptyArray(item.refundList)) {
          item.refundList.forEach(item => {
            if (item.status == '5') {
              max = this.$bigNumber(max, '-', item.amount)
            }
          })
        }
        return Number(max);
      }
    },
    showMax() {
      return function (item) {
        return Utils.lt(this.price, this.computedMaxRefund(item)) ? Number(this.price) : Number(this.computedMaxRefund(item));
      }
    },
  },
  filters: {
    filterPayWay(val, PAY_WAY) {
      return dictText(val, PAY_WAY)
    }
  },
  // 页面初始化
  async created() {
    this.PAY_WAY = await CommonDTO.getPayWay()
    this.intData()
  },
  // 页面DOM加载完成
  mounted() { },
  //离开页面时执行
  destroyed() { },
  // 页面方法
  methods: {
    intData(){
      this.notYbRecord = []
      this.cash = 0
      let ybTotal = 0
      // resource 来源 0退款项目 1退款管理 2未完成收费继续收费
      let { orderId, record, refundTotal, resource, isHasYB, refundList } = this.dialogObj
      this.orderId = orderId
      record.forEach(item => {
        item.maxRefundAmount = Number(item.payPrice)
        item.refundAmount = ''
      })
      if (isHasYB) {
        this.ybRecord = record.filter(item => { return item.payWay == '1' && (isNull(item.refundList) || isEmptyArray(item.refundList)) })
      }
      if (!isNull(this.ybRecord)) {
        this.ybRecord.forEach(yItem => {
          ybTotal = this.$bigNumber(yItem.payPrice, '+', ybTotal)
        })
      }
      this.ybTotal = ybTotal //医保总价
      let notYbTotal = this.$bigNumber(refundTotal, '-', ybTotal)  //非医保总价
      let total = 0
      record.forEach(item => {
        if (item.payWay == '2') {
          total = this.$bigNumber(total, '+', item.payPrice)
        }
      })

      if (Utils.lt(ybTotal, refundTotal)) {
        // this.cash = this.$bigNumber(Utils.lt(refundTotal, total) ? refundTotal : total,'-',ybTotal)
        this.cash = notYbTotal
      } else {
        this.cash = 0
      }
      this.notYbRecord = record.filter(item => { return item.payWay != '1' && item.payWay != '2' })
      this.computedShow(this.notYbRecord, refundTotal)
      this.price = refundTotal
      console.log(this.notYbRecord, 333333);
    },
    /**
     * 价格显示规则计算
     */
    computedShow(list, refundTotal) {
      if (isEmptyArray(list)) return  
      let total = this.$bigNumber(deepClone(refundTotal), '-', this.ybTotal)
      list.forEach(item => {
        let max = this.computedMaxRefund(item)
        if (Utils.gt(total, max)) {
          item.refundAmount = max
          total = this.$bigNumber(total, '-', max)
        } else {
          item.refundAmount = total
          total = this.$bigNumber(total, '-', total)
        }
      })
      list = list.filter(obj => { return Utils.gt(obj.refundAmount, 0) })
      this.notYbRecord = list
      this.cash = total
    },

    /**
     * 金额改变
     */
    amountChange(current, old, item) {
      if (isNull(current)) item.refundAmount = 0
      let total = 0
      this.notYbRecord.forEach(obj => {
        total = this.$bigNumber(obj.refundAmount, '+', total)
      })
      this.cash = this.$bigNumber(this.$bigNumber(this.price, '-', total), '-', this.ybTotal)

    },
    /**
    * 确定
    */
    confirm() {
      if (Utils.lt(this.cash, 0)) return this.$message.error('各支付方式的退款金额总和不能大于【需退费金额】')
      if (this.refundWay == '2') {
        // 直接用现金退
        let obj = this.refundObj
        let taskDetails = []
        taskDetails[0] = { refundWay: 2, amount: this.cash }
        if (!isEmptyArray(this.ybRecord)) {
          let ybItem = this.ybRecord[0]
          taskDetails.push({
            isMutualAidPay: ybItem.isMutualAidPay,
            orderPayNumber: ybItem.orderPayNumber,
            refundWay: ybItem.payWay,
            amount: ybItem.payPrice,
            ybInfo: ybItem.ybInfo
          })
        }
        obj.taskDetails = taskDetails
        this.handleRefund(obj)
      } else {
        let taskDetails = []//退款明细
        if (!isEmptyArray(this.ybRecord)) {
          this.ybRecord.forEach(item => {
            taskDetails.push({
              isMutualAidPay: item.isMutualAidPay,
              orderPayNumber: item.orderPayNumber,
              refundWay: item.payWay,
              amount: item.payPrice,
              ybInfo: item.ybInfo
            })
          })
        }
        if (!isEmptyArray(this.notYbRecord)) {
          this.notYbRecord.forEach(item => {
            if (Utils.gt(item.refundAmount, 0)) {
              taskDetails.push({
                orderPayNumber: item.orderPayNumber,
                refundWay: item.payWay,
                amount: item.refundAmount
              })
            }
          })
        }
        if (Utils.gt(this.cash, 0)) taskDetails.push({ refundWay: 2, amount: this.cash })
        this.refundObj.taskDetails = taskDetails
        this.handleRefund(this.refundObj)
      }
    },

    /**
     * 执行退款
     */
    handleRefund(refundObj) {
      this.loading = true
      let { orderId, refundTotal, refundList, resource,isStandby } = this.dialogObj
      if (resource != 1) {
        let obj = { orderId, orderType: '4', amount: refundTotal, }
        if (!isNull(refundList) && resource != 2) obj.refundTaskList = refundList
        payDTO.createRefundTaskBatch(obj).then(res => {
          if (res.code == 200) {
            refundObj.refundTaskId = res.data.id
            payDTO.editRefundTaskDetail(refundObj).then(async res => {
              if (res.code == 200) {
                let preParams = { deptId: this.$session.get('deptId') }
                let params = {}
                let ybList = res.data.filter(item => { return item.refundWay == '1' })
                let list = res.data.filter(item => { return item.refundWay != '1' })
                for (const item of list) {
                  preParams.refundTaskDetailId = item.id
                  params.refundWay = item.refundWay
                  await this.refund(preParams, params)
                }
                if (isNull(ybList) || isEmptyArray(ybList)) {
                  this.loading = false
                  this.$message.success('操作成功，请在退款管理中查看退款进度。')
                  this.$emit('updateData')
                } else {
                  let gjIndex = refundObj.taskDetails.findIndex(item => { return item.refundWay == '1' && item.isMutualAidPay })
                  if (gjIndex > -1) {
                    //有共济支付 先退共济，后退医保
                    let gjItem = ybList.find(item => { return item.isMutualAidPay })
                    let ybItem = ybList.find(item => { return !item.isMutualAidPay })
                    let gjPreParams = { ...preParams }
                    let gjParams = {}
                    let ybPreParams = { ...preParams }
                    let ybParams = {}
                    refundObj.taskDetails.forEach(obj => {
                      if (obj.orderPayNumber == gjItem.orderPayNumber) { gjParams.attach = obj.ybInfo, gjPreParams.isMutualAidPay = obj.isMutualAidPay }
                      if (obj.orderPayNumber == ybItem.orderPayNumber) { ybParams.attach = obj.ybInfo, ybPreParams.isMutualAidPay = obj.isMutualAidPay }
                    })
                    gjPreParams.refundTaskDetailId = gjItem.id
                    ybPreParams.refundTaskDetailId = ybItem.id
                    gjParams.refundWay = gjItem.refundWay
                    ybParams.refundWay = ybItem.refundWay
                    gjPreParams.refundReason = this.refundObj.refundReason
                    ybParams.refundReason = this.refundObj.refundReason
                    await gjCancelSettlement(gjPreParams, gjParams, this)
                    await cancelSettlement(ybPreParams, ybParams, this)
                  } else {
                    //没有共济支付
                    let ybItem = ybList[0]
                    refundObj.taskDetails.forEach(obj => {
                      if (obj.orderPayNumber == ybItem.orderPayNumber) { params.attach = obj.ybInfo }
                    })
                    preParams.refundTaskDetailId = ybItem.id
                    params.refundWay = ybItem.refundWay
                    params.refundReason = this.refundObj.refundReason
                    await cancelSettlement(preParams, params, this)
                  }
                  this.$message.success('操作成功，请在退款管理中查看退款进度。')
                  this.loading = false
                  this.$emit('chargeRefundDialogConfirm')
                }
              } else {
                this.loading = false
                this.$emit('chargeRefundDialogConfirm')
              }
            }).catch(() => {
              this.loading = false
              this.$emit('chargeRefundDialogConfirm')
            })
          } else {
           this.loading = false
           this.dialogObj.refundTotal = res.data
           this.price = res.data
           this.intData()
          }
        })
      } else {
        refundObj.taskDetalId = this.dialogObj.taskDetalId
        payDTO.changeTaskDetail(refundObj).then(async res => {
          if (res.code == 200) {
            let preParams = { deptId: this.$session.get('deptId') }
            let params = {}
            let list = res.data
            for (const item of list) {
              refundObj.taskDetails.forEach(obj => {
                if (obj.orderPayNumber == item.orderPayNumber) { params.attach = obj.ybInfo }
              })
              preParams.refundTaskDetailId = item.id
              params.refundWay = item.refundWay
              isStandby ? await payDTO.standbyRefund(preParams, params) : await this.refund(preParams, params)
              this.loading = false
              this.$message.success('操作成功，请在退款管理中查看退款进度。')
              this.$emit('chargeRefundDialogConfirm')
            }
          } else {
            this.loading = false
            this.dialogVisible('chargeRefundDialog')
          }
        }).catch(() => {
          this.loading = false
          this.dialogVisible('chargeRefundDialog')
        })
      }

    },
    /**
     * 预退款+退款
     */
    async refund(preParams, params) {
      if (params.refundWay == '3') {
        return new Promise((resolve, reject) => {
          payDTO.refundFun(preParams).then(async refundRes => {
            if (refundRes.code == 200) {
              resolve()
            } else {
              resolve()
              this.loading = false;
            }
          }).catch(err => {
            resolve()
            this.loading = false;
          })
        })

      } else {
        return new Promise((resolve, reject) => {
          payDTO.refundFun(preParams).then(async res => {
            if (res.code == 200) {
              let time = await CommonDTO.getSystemTimeDTO()
              let obj = {
                refundNumber: res.data.refundNumber,
                refundStatus: '1',
                amount: res.data.preRefundAmount,
                refundTime: this.$moment(time).format('YYYY-MM-DD HH:mm:ss'),
                reason: this.refundObj.refundReason,
                attach: {},
              }
              payDTO.refundCallback(obj).then(res2 => {
                if (res2.code == 200) {
                  resolve(res2)
                } else {
                  resolve(res2)
                  this.loading = false;
                }
              }).catch(err => {
                resolve(res2)
                this.loading = false;
              })
            } else {
              resolve(res2)
              this.loading = false
            }
          }).catch((err) => {
            this.loading = false
            resolve(err)
          })
        })
      }

    },

    /**
     * 创建退款单
     */
    async createRefundTask(obj) {
      this.loading = true
      let { code, data } = await payDTO.createRefundTaskBatch(obj)
      if (code == 200) {
        this.loading = false
        this.refundObj.refundTaskId = data.id
      } else {
        this.loading = false
      }
    },

    /**
    * 关闭
    */
    dialogVisible(name) {
      this.$emit("close", name);
    },
    /**
     * 切换退款方式
     */
    changeRefundWay(val) {
      if (val == '2') {
        this.cash = this.$bigNumber(this.price, '-', this.ybTotal)
      } else {
        this.computedShow(this.notYbRecord, this.price)
      }
    }

  },
}
</script>
<style lang="less" scoped>
.refund {
  .disabled {
    background: #f8f9f9;
    cursor: not-allowed;
  }

  /deep/.el-input.is-disabled .el-input__inner {
    background: #F0F1F3;
  }

  .price-warp {
    text-align: center;
    color: #FE8F1F;
    font-size: 24px;
    font-weight: bold;
  }

  .refund-item {
    padding-bottom: 16px;
    border-bottom: 1px dashed #EBEAEE;
    margin-bottom: 12px;

    &:last-child {
      border-bottom: none;
      margin-bottom: 0
    }
    .error_tips{
      padding: 10px 18px;
      background: #ffe2e2;
      border-radius: 2px 2px 2px 2px;
      color: #1F2329;
      font-size: 13px;
      display: flex;
      margin-top: 16px;
    }
    .tips {
      padding: 10px 18px;
      background: #E8F4FF;
      border-radius: 2px 2px 2px 2px;
      color: #1F2329;
      font-size: 13px;
      display: flex;
      margin-top: 16px;
    }

    .input-warp {
      display: flex;
      align-items: center;
      border: 1px solid #D3D3D5;
      margin-top: 8px;
      border-radius: 2px;

      /deep/.el-input-number__decrease {
        display: none;
      }

      /deep/.el-input-number__increase {
        display: none;
      }

      .input-label {
        width: 88px;
        flex-shrink: 0;
        background: #F0F1F3;
        height: 42px;
        line-height: 42px;
        text-align: center;
        border-right: 1px solid #D3D3D5;
      }

      /deep/.el-input__inner {
        border-color: transparent;
        text-align: left;
        padding: 0;
        padding-left: 20px;
        border-color: transparent !important;
      }

      .input-tips {
        flex: 1;
        height: 42px;
        line-height: 42px;
        color: #667182;
        font-size: 14px;
        flex-shrink: 0;
      }
    }
  }

}
</style>